import { Menu } from '@blueprintjs/core'
import {
  CulturePageFilterDefinitionsResponse,
  PlateFilter,
} from '~/api/backend/pages/culturesPageAPI'
import FilterMenuItem from './FilterMenuItem'
import cs from './filter_menu.scss'

function FilterMenu({
  filterDefinitions,
  setFilter,
  filters,
  openFilterModal,
}: {
  filterDefinitions?: CulturePageFilterDefinitionsResponse
  setFilter: (filterField: string, filter: PlateFilter | null) => void
  filters: PlateFilter[]
  openFilterModal: (filterField: string) => void
}) {
  // Note: The backend doesn't make a distinction between plate filters and culture filters.
  // We assume all filters are plate filters for now.
  if (!filterDefinitions || !filterDefinitions.filter_definitions) {
    return <Menu className={cs.noFilters}>No filters available</Menu>
  }

  return (
    <Menu className={cs.menu}>
      <div className={cs.divider}>Plate Filters</div>
      {filterDefinitions.filter_definitions.map(filter => (
        <FilterMenuItem
          filter={filter}
          key={filter.field}
          existingFilter={filters.find(f => f.field === filter.field)}
          setFilter={setFilter}
          openFilterModal={openFilterModal}
        />
      ))}
    </Menu>
  )
}

export default FilterMenu
